import React from 'react'
import { env_url } from '../../utils/js/endpoints'
import './TSCAdComponent.scss'

export default function TSCAdComponent(props) {
    const tfcImageSource =
        props.league === 'nba' ? `${env_url}/tsc_ad_nba.gif` : `${env_url}/tsc_ad_multi.gif`

    return (
        <div className="tsc-ad">
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.tsc.ca/pages/category?nav=n:2074009"
            >
                <img src={tfcImageSource} alt="tsc ad shop" />
            </a>
        </div>
    )
}
